/// <amd-module name="Search/Shared/Base/Scenario" />
import { IVssPerformanceService } from "VSS/Platform/Performance";
import { publishTelemetryEvent } from "Search/Shared/Base/Telemetry";
import * as CommonCIConstants from "Search/Shared/CustomerIntelligenceConstants";
import { IVssPageContext } from "VSS/Platform/Context";

export class HubTelemetryWriter {
    private tabSwitchTTIPending: { [key: string]: boolean } = {};
    private performanceService: IVssPerformanceService;

    constructor(private readonly scenarioName: string, private readonly pageContext: IVssPageContext) {
        this.performanceService = pageContext.getService<IVssPerformanceService>("IVssPerformanceService");
    }

    public markTTI = (scenarioName: string, additionalData: any, excludeFromTTI?: boolean) => {
        if (excludeFromTTI) {
            this.performanceService.endScenario(CommonCIConstants.SEARCH_AREA, scenarioName, false, undefined, this.getProps(additionalData));
        } else {
            this.performanceService.markTimeToInteractive(CommonCIConstants.SEARCH_AREA, scenarioName, undefined, this.getProps(additionalData));
        }
    }

    public markTabSwitch = (tabId: string, additionalData: any) => {
        if (!this.tabSwitchTTIPending[tabId]) {
            return;
        }

        delete this.tabSwitchTTIPending[this.scenarioName];
        this.performanceService.endScenario(CommonCIConstants.SEARCH_AREA, this.scenarioName, false, undefined, this.getProps({ ...additionalData, tabId }, true));
    }

    public startTabSwitch = (tabId: string) => {
        this.tabSwitchTTIPending[tabId] = true;
        this.performanceService.startScenario(this.scenarioName, false);
        this.performanceService.addSplitTiming(this.scenarioName, "tabLoadStarted")
    }

    public publish = (telemetryEvent: string, properties: { [key: string]: any }): void => {
        publishTelemetryEvent(this.pageContext, telemetryEvent, "SearchHub", properties);
    }

    private getProps = (addionalData: any, isTabSwitch?: boolean) => {
        let allProps: { [key: string]: any } = { ...addionalData, isLWP: true };
        if (isTabSwitch) {
            allProps["isTabSwitch"] = isTabSwitch;
        }

        return allProps;
    }
}